import DynamicBanner from './DynamicBanner';

const DynamicBannerConfig = {
	settings: {},
	routes: [
		{
			path: '/apps/dynamic-banner',
			component: DynamicBanner
		}
	]
};

export default DynamicBannerConfig;
